import React from 'react';
import {StyleSheet, Text, View, Picker} from 'react-native';
import Themes from '../../themes';

const SelectInput = ({
  label,
  onValueChange,
  selectedValue,
  data,
  noDefaultValue,
}) => {
  console.log(data);
  return (
    <>
      <Text style={styles.label}>{label}</Text>
      <View style={styles.container}>
        <Picker
          style={styles.input}
          selectedValue={selectedValue}
          onValueChange={onValueChange}>
          {!noDefaultValue && (
            <Picker.Item
              key="default"
              label="Veuillez choisir une valeur"
              value="default"
            />
          )}
          {data.map((itemData, key) => (
            <Picker.Item
              key={key}
              label={itemData.label}
              value={itemData.value}
            />
          ))}
        </Picker>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  label: {
    color: '#BEBEBE',
    fontSize: 14,
    lineHeight: 20,
    fontFamily: 'Roboto-Bold',
    marginBottom: 5,
  },
  container: {
    borderColor: '#BEBEBE',
    borderWidth: 1,
    marginBottom: 5,
  },
  input: {
    height: 45,
    width: '100%',
    fontSize: 14,
    fontFamily: 'Roboto-Bold',
    color: Themes.colors.blue,
  },
});

export default SelectInput;
